import TableHeadings from '../../Components/common-components/table-headings';
import CreateIcon from '@mui/icons-material/Create';
import useAccounts from './Hooks/useAccounts';
import { Spinner } from '../../Components/common-components/spinner';
import PaginationCom from '../../Components/Pagination';
import { toast, ToastContainer } from 'react-toastify';
import { NavLink } from 'react-router-dom';
import superBillActive from '../../Assets/sidenav_icons/superBillActive.png'

const TableHeadData = [
    { label: '#' },
    { label: 'Patient Name' },
    { label: "Provider Name" },
    { label: 'Billing Provider Name' },
    { label: 'CPT' },
    { label: 'Total Amount' },
    { label: 'Case Type' },
    { label: 'Insurance Name' },
    { label: 'Location Name' },
    { label: 'Action' },
    { label: 'Generate ADA Form' },
]

const SuperBill = () => {
    const { methods, data } = useAccounts()
    const {
        setController,
        handleGenerateAda
    } = methods

    const {
        spinner,
        totalCount,
        controller,
        patientSuperBillList
    } = data

    return (
        <div>
            {spinner && <Spinner />}
            <ToastContainer limit={1} autoClose={1000} />
            <div className=''>
                <div>
                    <div className='text-center section_header'>SuperBill</div>
                    {/* List */}
                    <div className="col-12 mt-3 p-2 " >
                        <table className="customTable">
                            <TableHeadings TableHeadData={TableHeadData} />
                            <tbody>
                                {
                                    patientSuperBillList?.length > 0 ? (
                                        patientSuperBillList.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{`${item.patientFirstName || ""} ${item.patientLastName || ""}`}</td>
                                                <td>{`${item.providerFirstName || ""} ${item.providerLastName || ""}`}</td>
                                                <td>{`${item.billingProviderFirstName || ""} ${item.billingProviderLastName || ""}`}</td>
                                                <td>
                                                    {
                                                        item.cptCode
                                                            .map(code => code?.cptDetailsData?.code)
                                                            .filter(Boolean) // Removes undefined/null values
                                                            .join(', ')
                                                    }
                                                </td>
                                                <td>{item.totalAmount || "0"}</td>
                                                <td>{item.caseType || ""}</td>
                                                <td>{item.insuranceCompanyName || ""}</td>
                                                <td>{item.clinicName || ""}</td>
                                                <td>
                                                    <NavLink to={`/superbill/${item.id}`} className='d-flex'>
                                                        <CreateIcon className='cursor ms-2' color="primary" titleAccess='Edit' />
                                                    </NavLink>
                                                </td>
                                                <td>
                                                    <div onClick={() => handleGenerateAda(item.id)}>
                                                        <img alt="" src={superBillActive} />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="12" className="text-center">No records found</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                        {/* {!patientSuperBillList?.length && <ListingSkeleton listLength={8} />} */}
                        {/* <div className="d-flex justify-content-center mt-2">
                            {
                                totalCount > 10 && <PaginationCom count={totalCount} controller={controller} setController={setController} />
                            }
                        </div> */}
                    </div>
                </div>

            </div>


        </div>
    )
}

export default SuperBill